module.exports = __webpack_public_path__ + "img/sent_white.ffe61de9.svg";